class Menu {

  constructor(elem) {
    this.menu = elem;
	}

  initialize() {
    let menu = this.menu;
    let close = menu.find('[data-menu-close]');
    let back = menu.find('[data-menu-back]');
    let dropdownMenu = menu.find('[data-about-dropdown-menu]');
    let dropdownHeader = dropdownMenu.find('[data-about-dropdown-header]');

    let dropdownItems = dropdownMenu.find('[data-about-dropdown-item]');

    const wd = $(window).width();

    if (menu.is('[data-menu-about]')) {
      let dropdownContent = $(dropdownHeader).next();

      dropdownHeader.on('click', function(e) {
        dropdownHeader.toggleClass('active');
        dropdownContent.toggleClass('active');
      });

      dropdownItems.on('click', function(e) {
        let trg = $(this);

        if(trg.hasClass('active')){
          dropdownItems.removeClass('active');
        }
        else {
          dropdownItems.removeClass('active');
          trg.addClass('active');
        }
      });
    }

    menu.find('a').on('click', function(e) {
      let el = $(this);
      let ww = $(window).width();

      if (ww < 992) {
        if (el.hasClass('menu__link--drop') || el.hasClass('menu__title-drop-list')) {
          el.parent().toggleClass('active');

          e.preventDefault();
        }
      }

    });

    close.on('click', function(e) {
      let el = $(this);
      el.closest('[data-menu]').removeClass('active');
      el.closest('[data-menu]').find('.active').removeClass('active');
      $('body').removeClass('overflow');
      $('html').removeClass('overflow');

      e.preventDefault();
    });

    back.on('click', function(e) {
      let el = $(this);
      el.closest('li').removeClass('active');

      e.preventDefault();
    });

    if (menu.find('[data-tab-sublist-link]').length > 0 && $('[data-tabs-header]').length > 0) {
      let sublistLink = menu.find('[data-tab-sublist-link]');
      sublistLink.on('click', function(e) {
        e.preventDefault();

        let href = $(this).attr('href');
        let link = $('[data-tabs-header]').find('a');
        link.each(item => {
          if ($(link[item]).attr('href') === href) {
            $(link[item]).trigger('click');
          }
        });
      });
    }
  }

  scrollTo() {
    let menu = this.menu;
    let el = menu.find('a');

    el.on('click', (e) => {
      this.scrollEl(el, e);
    });
  }

  scrollToSingle() {
    let menu = this.menu;

    menu.on('click', (e) => {
      this.scrollEl(menu, e);
    });
  }

  scrollEl(el, e) {
    let target = el.attr('href');
    let partTop = $(target).offset().top - $(window).height() / 4;

    $('html, body').animate({scrollTop: partTop + 'px'}, 500);
    if (el.attr('data-scroll-to-single') === 'avail') {
      $(target).find('[data-avail]').trigger('click');
    }

    e.preventDefault();
  }
}

export {Menu};

$(function() {
  window.Menu = Menu;
});

$(window).on('load', () => {
  let menus = [];
  let menusScroll = [];
  let menusSingle = [];

  // Если существует меню со ссылками якорями
  if ($('[data-scroll-to]').length > 0) {
		$('[data-scroll-to]').each(function(i) {
			menusScroll[i] = new Menu($(this));
			menusScroll[i].scrollTo();
		});
	}

  // Отдельная ссылка - якорь к блоку
  if ($('[data-scroll-to-single]').length > 0) {
		$('[data-scroll-to-single]').each(function(i) {
			menusSingle[i] = new Menu($(this));
			menusSingle[i].scrollToSingle();
		});
	}

  // Верхнее меню
  if ($('[data-menu]').length > 0) {
		$('[data-menu]').each(function(i) {
			menus[i] = new Menu($(this));
			menus[i].initialize();
		});
	}
});
